import SecureLinkAnalytics from './SecureLinkAnalytics.component';

export default SecureLinkAnalytics;